<template>
  <LoaderMonitor :optional="true">
    <template #default="{ sessionState, sessionId }">
      <AiApiAssistant
        :sessionState="sessionState"
        :sessionId="sessionId"
        v-bind="$attrs"
      />
    </template>
  </LoaderMonitor>
</template>

<script>
import LoaderMonitor from '../LoaderMonitor.vue';
import AiApiAssistant from '../website/AiApiAssistant.vue';

export default {
  name: 'AiApiAssistantWrapper',
  components: {
    LoaderMonitor,
    AiApiAssistant
  }
};
</script>